/* ========================================================================
 *  module Learning Subscription
 * ========================================================================
*/
FD.LEARNINGSUBSCRIPTION = (function ($, me) {
    'use strict';

    var child = me.LEARNINGSUBSCRIPTION || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_LEARNINGSUITE = '/LearningSuite/';
    var MODAL_ELEM = '#LEARNING_SUBSCRIPTION_MODAL';
    var SUBSCRIPTION_TAG_CONTAINER = '#SUBSCRIPTION_TAG_CONTAINER';
    var SUBSCRIPTION_CR_CONTAINER = '#SUBSCRIPTION_CR_CONTAINER';
    var modal;
    var notify;
    var label;
    var editing = false;

    var modalOptions = {};
    var defaults = {
        updateCallback: null,
        hideCallBack: null
    };

    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        ADD_TAG: 12,
        DELETE_TAG: 13, 
        
        SUBSCRIBE_CR: 500,
        UNSUBSCRIBE_CR: 501
    };


    /*
    * ========================================================================
    * Objects
    * ========================================================================
    */




    /* ========================================================================
     *  CRUD Functions
     * ========================================================================
    */

    function handleTagSubscriptionCRUD(data) {
        data.containerElem = SUBSCRIPTION_TAG_CONTAINER;
        data.deletTag = tag.DELETE_TAG;
        data.action = data.value !== true ? "HandleTagSubscriptionAddCRUD" : "HandleTagSubscriptionDeleteCRUD";
        if (data.value !== true && $("[data-parentid=" + data.value + "]", SUBSCRIPTION_TAG_CONTAINER).length > 0) {
            data.e.data({
                initial: null,
                value: null
            }).val('');
            return;
        }
        handleSubscriptionCRUD(data);
    }


    function handleCRSubscriptionCRUD(data) { 
        data.containerElem = SUBSCRIPTION_CR_CONTAINER;
        data.deletTag = tag.UNSUBSCRIBE_CR;
        data.action = data.value !== true ? "HandleCRSubscriptionAddCRUD" : "HandleCRSubscriptionDeleteCRUD";
        if (data.value !== true && $("[data-parentid=" + data.value + "]", SUBSCRIPTION_CR_CONTAINER).length > 0) {
            data.e.data({
                initial: null,
                value: null
            }).val('');
            return;
        }       
        handleSubscriptionCRUD(data);
    }


    function handleSubscriptionCRUD(data) {
        var options = {
            url: URL_LEARNINGSUITE + data.action,
            params: {
                ID: parseInt(data.value !== true ? data.value : data.parentid)
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                getSubscriptionList(data);
                data.e.data({
                    initial: null,
                    value: null
                }).val('');

                if (modalOptions.updateCallback && typeof modalOptions.updateCallback === 'function') {
                    modalOptions.updateCallback(data);
                }
            }
        }
    }


    /*
    * ========================================================================
    * Partial Views
    * ========================================================================
    */

    //  load modal
    function showLearningSubscriptionModal() {
        if (me.getModalLock()) {
            return;
        }

        me.setModalLock(true);
        var options = {
            params: {},
            url: URL_LEARNINGSUITE + 'GetLearningSubscriptionModal',
            callback: afterData,
            ishtml: true,
            cancelprevious: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {

            $('body').append(result.data);

            modal = $(MODAL_ELEM);

            modal.off().on('shown.bs.modal', function () {
                me.CONTROL.setSelect(true, modal);
                me.CONTROL.setButton(true, modal);
                me.CONTROL.setAutoComplete(modal);
                if (notify !== null) {
                    notify = new Notify();
                }
                label = me.getLabel();
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                $(MODAL_ELEM).remove();
                if (modalOptions.hideCallback && typeof modalOptions.hideCallback === 'function') {
                    modalOptions.hideCallback();
                }
            }).modal('show');
        }
    }


    function getSubscriptionList(data) {
        var options = {
            url: URL_LEARNINGSUITE + "GetSubscriptionList",
            params: {
                deleteTagId: data.deletTag,
                isCR: data.deletTag === tag.UNSUBSCRIBE_CR
            },
            isloader: true,
            ishtml: true,
            callback: afterData
        };
        me.AJAX.setAJAX(options);
        function afterData(result) {
            if (result.data) {
                $(data.containerElem).html(result.data);
                me.CONTROL.setButton(true, $(data.containerElem));
            }
        }
    }


    /* ========================================================================
     *  Helper Methods
     * ========================================================================
    */


    /* ========================================================================
     *  page init
     * ========================================================================
    */


    child.init = function () { };

    // Display update learning subscription modal
    // options: learning subscription modal options
    // updateCallback: This is used to fire a callback from the function passed in
    // hideCallback: This is called when the modal is hidden.
    child.showLearningSubscriptionModal = function (options) {
        modalOptions = $.extend({}, defaults, options);
        showLearningSubscriptionModal();
    };

    child.handleCRSubscriptionCRUD = function (options) {       
        handleCRSubscriptionCRUD(options);
    };
    //   after control event
    child.getAfterControlEvent = function (data) {
        switch (data.tag) {
            case tag.ADD_TAG:
            case tag.DELETE_TAG:
                handleTagSubscriptionCRUD(data);
                break;
            case tag.UNSUBSCRIBE_CR:
            case tag.SUBSCRIBE_CR:
                handleCRSubscriptionCRUD(data);
                break;
        }
    };

    return child;
}(jQuery, FD));